(function ($) {

    var stickyButton = $('.js-sticky-cta-button');
    var blockStickyButton = $('.js-sticky-block-button');
    var blockStickyCombined = $('.js-sticky-cta-button, .js-sticky-block-button .btn-fixed-tr');
    let isShortPage = $(document).height() < 1600;
    let hiderTimeout;

    $(window).scroll(function () {

        // slide global cta button in if block cta does not exist
        if (($(window).scrollTop() > 200) && stickyButton.length || isShortPage) {

            clearTimeout(hiderTimeout);

            if (blockStickyButton.length && !blockStickyButton.hasClass('cta-enter')) {
                stickyButton.removeClass('is-fixed');
            } else {

                stickyButton.addClass('is-fixed');
                blockStickyCombined.removeClass('is-end');
            }
        } else {
            stickyButton.removeClass('is-fixed');
        }

        if (stickyButton.length) {
            blockStickyButton.addClass('has-global-cta');
        }

        // slide button off screen once user reaches the end of the page
        if ($(window).scrollTop() + $(window).height() > ($(document).height() - 150) && !isShortPage) {
            blockStickyCombined.addClass('is-end');
        } else if ($(window).scrollTop() + $(window).height() == ($(document).height()) && isShortPage) {

            let hiderTimeout = setTimeout(() => {
                blockStickyCombined.addClass('is-end');
            }, 500);
        } else {
            blockStickyCombined.removeClass('is-end');
        }

    });

}(jQuery));
